class Experience {

    constructor(callback) {
        console.log('call Experience class')
        this.init(callback);
    }

    init(callback) {
        if (sessionStorage.getItem("experiences") === null) {
            this.getExperiencesFromAPI().then(async response => {
                await this.loadExperiencesToBrowser(response);
                if (callback) {
                    callback.bind(this)();
                }
            });
            // console.log(this.experiences);
        } else {
            this.experiences = sessionStorage.getItem("experiences");
            if (callback) {
                callback.bind(this)();
            }
        }
    }

    async loadExperiencesToBrowser(experiences) {
        console.log('loadExperiencesToBrowser');
        console.log(experiences);
        // await this.experiences
        let experiencesArray = [];
        for (let i = 0; i < experiences.length; ++i) {

            // set arrivaloffset to 0 in cases where it is not set in Xola to prevent error
            let arrivalOffset;
            !experiences[i]['arrivalOffset'] ? (arrivalOffset = 0) : (arrivalOffset = experiences[i]['arrivalOffset']);
            let demographics = experiences[i]['demographics'];
            console.log(demographics);
            let demographicsArray = this.returnDemographicsArray(demographics);

            // console.log(experiences[i].getAttribute('data-name'));
            let element = {
                'name': experiences[i]['name'],
                'id': experiences[i]['id'],
                'price': experiences[i]['priceSchemes'][0]['price'],
                'arrivalOffset': arrivalOffset,
                'demographics': demographicsArray
            };
            experiencesArray.push(element);
        }
        let jsonString = JSON.stringify(experiencesArray);
        sessionStorage.setItem("experiences", jsonString);
    }

    returnDemographicsArray(demographics) {
        console.log(demographics)
        console.log(demographics.length)
        let demographicsArray = [];
        for (let i = 0; i < demographics.length; ++i) {
            demographicsArray.push({'id': demographics[i]['id'], 'labelCanonical': demographics[i]['labelCanonical']});
        }
        return demographicsArray;
    }


    returnExperienceObject() {
        let returnedObject = sessionStorage.getItem("experiences");
        console.log(returnedObject);
        return JSON.parse(returnedObject);
    }

    async getExperiencesFromAPI() {
        let experiencesArray = [];
        await getExperiences().then(response => {
            response['data'].forEach(el => {
                experiencesArray.push(el);
            })
        });
        return experiencesArray;
    }

    getExperienceNames() {
        let experiences = this.experiences;
        let experienceNames = [];
        for (let i = 0; i < experiences.length; ++i) {
            // console.log(experiences[i].getAttribute('data-name'));
            experienceNames.push(experiences[i].getAttribute('data-name'));
        }
        return experienceNames;
    }


    getExperienceIDs() {
        let experiences = this.experiences;
        let experienceIDs = [];
        for (let i = 0; i < experiences.length; ++i) {
            // console.log(experiences[i].getAttribute('data-name'));
            experienceIDs.push(experiences[i].getAttribute('data-experience-id'));
        }
        return experienceIDs;
    }

}
